module.exports = __webpack_public_path__ + "assets/img/img332.79331fed.png";